import React from "react";
import { useTranslation } from "react-i18next";
import { withRouter } from "react-router-dom";

import { PageTitle } from "../../components/Common/PageTitle";

const InstagramDeletedPage: React.FunctionComponent = () => {
  const { t: _t } = useTranslation();
  const t = (key: string) => _t(`instagramDeletedPage.${key}`);

  return (
    <div className="right-content instagram-integrate">
      <div className="top-title-bar flex-grid">
        <PageTitle text={t("instagram_integration_deleted")} />
      </div>
      <p>
        <strong>{t("instagram_integration_deleted_description")}</strong>
      </p>
    </div>
  );
};

export default withRouter(InstagramDeletedPage);
